// ui/src/Forms/Loaders/components/RadioSkeleton.js
import { Mui } from "@osu/react-ui";

function RadioSkeleton() {
  return (
    <Mui.Box sx={{ mb: 3 }}>
      <Mui.Skeleton variant="text" width="45%" height={24} />
      <Mui.Box sx={{ mt: 1, ml: 1 }}>
        <Mui.Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Mui.Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
          <Mui.Skeleton variant="text" width="15%" height={24} />
        </Mui.Box>
        <Mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Mui.Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
          <Mui.Skeleton variant="text" width="10%" height={24} />
        </Mui.Box>
      </Mui.Box>
    </Mui.Box>
  );
}

export default RadioSkeleton;
